import React from "react";
import "./_press.scss";
import Title from "../Title/Title";

const PressRelease = () => {
  return (
    <div
      className="container-lg mb-5"
      id="press"
      style={{ paddingBottom: "5rem", marginTop: "4rem" }}
    >
      <div className="farming-header">
        <Title
          top="Press"
          bottom={"releases"}
          align="d-flex gap-3 mb-5 justify-content-center"
        />
      </div>
      <div className="position-relative overflow-hidden">
        <div className="leftbg"></div>
        <table className="presstable">
          <tbody className="pressbody">
            <tr>
              <td className="radius1 presscell"></td>
              <td className="presscell radius2">
                {/* <a
                  href="https://coinmarketcap.com/headlines/news/dyp-finance-a-unique-yield-farming-platform/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coinmarketcap.png"} alt="" />
                </a> */}
                <a
                  href="https://cryptoadventure.com/caws-the-cats-and-watches-society-nft-collection-by-dypius/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptoadventure.png"} alt="" />
                </a>
              </td>
              <td className="radius1 presscell"></td>
              <td className="radius1 presscell">
                <a
                  href="https://www.bitcoininsider.org/article/100387/defi-yield-protocol-dyp-provides-new-level-transparency-market"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/bitinsider.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius4">
                <a
                  href="https://cryptoadventure.co.uk/coingecko-and-dypius-partner-to-build-and-pioneer-innovation-on-the-world-of-dypians/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptoadventure.png"} alt="" />
                </a>
              </td>
              <td className="radius4 presscell"></td>

              <td className="radius2 presscell">
                {/* <a
                  href="https://medium.com/the-capital/defi-yield-protocol-dyp-staking-and-governance-is-now-live-e18c0f14a442"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/medium.png"} alt="" />
                </a> */}
                <a
                  href="https://finance.yahoo.com/news/world-dypians-announces-whitelisting-genesis-180000531.html"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/yahoo.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius1"></td>
              <td className="presscell radius5">
                <a
                  href="https://news.bitcoin.com/dyp-launches-staking-and-governance-dapp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/bitcoincom.png"} alt="" />
                </a>
              </td>
              <td className="radius6 presscell">
                {" "}
                <a
                  href="https://hackernoon.com/coingecko-and-dypius-partner-up-to-build-innovation-in-the-world-of-dypians"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/hackernoon.png"} alt="" />
                </a>
              </td>
              <td className="radius5 presscell">
                <img src={"https://cdn.worldofdypians.com/dypius/gateioNews.png"} alt="" />
              </td>
              <td className="presscell radius2"></td>
              <td className="radius1 presscell"></td>
              <td className="radius6 presscell">
                <a
                  href="https://bitcoinist.com/defi-yield-protocol-debuts-new-staking-and-governance-dapp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/bitcoinist.png"} alt="" />
                </a>
              </td>
              <td className="radius1 presscell"></td>
              <td className="presscell radius2">
                {/* <a
                  href="https://coinmarketcap.com/headlines/news/dyp-finance-a-unique-yield-farming-platform/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coinmarketcap.png"} alt="" />
                </a> */}
                <a
                  href="https://www.benzinga.com/pressreleases/23/02/g30736707/world-of-dypians-announces-whitelisting-for-genesis-land-nfts-at-knockdown-price"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/benzinga.png"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>
              <td className="radius1 presscell"></td>
              <td className="radius1 presscell">
                <a
                  href="https://www.bitcoininsider.org/article/100387/defi-yield-protocol-dyp-provides-new-level-transparency-market"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/bitinsider.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius4"></td>
              <td className="radius4 presscell"></td>

              <td className="radius2 presscell">
                {/* <a
                  href="https://medium.com/the-capital/defi-yield-protocol-dyp-staking-and-governance-is-now-live-e18c0f14a442"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/medium.png"} alt="" />
                </a> */}
                <a
                  href="https://finance.yahoo.com/news/dypius-partners-conflux-network-unveils-150000764.html"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/yahoo.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius1"></td>
              <td className="presscell radius5">
                <a
                  href="https://news.bitcoin.com/dyp-launches-staking-and-governance-dapp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/bitcoincom.png"} alt="" />
                </a>
              </td>
              <td className="radius6 presscell"></td>
              <td className="radius5 presscell">
                <img src={"https://cdn.worldofdypians.com/dypius/gateioNews.png"} alt="" />
              </td>
              <td className="presscell radius2"></td>
              <td className="radius1 presscell"></td>
              <td className="radius6 presscell">
                <a
                  href="https://bitcoinist.com/defi-yield-protocol-debuts-new-staking-and-governance-dapp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/bitcoinist.png"} alt="" />
                </a>
              </td>
            </tr>
            <tr>
              <td className="radius10 presscell"></td>
              <td className="presscell radius5">
                <a
                  href="https://finance.yahoo.com/news/investors-defi-yield-protocol-earned-151500497.html"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/yahoo.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius10"></td>
              <td className="presscell radius2">
                {/* <a
                  href="https://www.marketwatch.com/press-release/dyp-protocol-launches-on-avalanche-and-introduces-new-nft-competition-2021-07-19?tesla=y"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/marketwatch.png"} alt="" />
                </a> */}
                <a
                  href="https://www.benzinga.com/pressreleases/23/07/g33217661/dypius-partners-with-conflux-network-unveils-nft-marketplace-and-new-game-update"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/benzinga.png"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>
              <td className="radius4 presscell"></td>
              <td className="presscell radius10">
                <a
                  href="https://apnews.com/press-release/accesswire/business-prices-deflation-economy-54076ee83d21025c63d8347c8accc1e2"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/apnews.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius1"></td>
              <td className="presscell radius7">
                {/* <a
                  href="https://www.cryptofolds.com/defi-yield-protocol-dyp-staking-and-governance-is-now-live"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptofold.png"} alt="" />
                </a> */}
                <a
                  href="https://www.globenewswire.com/news-release/2023/07/13/2704540/0/en/Dypius-Partners-with-Conflux-Network-Unveils-NFT-Marketplace-and-New-Game-Update.html"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/globalNewsWire.jpg"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>
              <td className="presscell radius10">
                <a
                  href="https://www.newsbtc.com/news/company/defi-yield-protocol-launches-staking-and-governance-dapp-dyp-holders-earn-ethereum/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/newsbtc.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius1"></td>
              <td className="presscell radius8"></td>
              <td className="presscell radius4">
              <a
                  href="https://finance.yahoo.com/news/dypius-enables-secure-cross-chain-114700063.html"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/yahoo.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius7">
                <a
                  href="https://hackernoon.com/5-defi-projects-you-should-know-about-in-2021-irq347a"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/hackernoon.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius1"></td>
              <td className="radius10 presscell"></td>
              <td className="presscell radius5">
                <a
                  href="https://finance.yahoo.com/news/investors-defi-yield-protocol-earned-151500497.html"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/yahoo.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius10"></td>
              <td className="presscell radius2">
                {/* <a
                  href="https://www.marketwatch.com/press-release/dyp-protocol-launches-on-avalanche-and-introduces-new-nft-competition-2021-07-19?tesla=y"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/marketwatch.png"} alt="" />
                </a> */}
                <a
                  href="https://markets.businessinsider.com/news/stocks/coingecko-and-dypius-partner-to-build-and-pioneer-innovation-on-the-world-of-dypians-1032652807"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/businessinsider.png"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>
              <td className="radius4 presscell">
              <a
                  href="https://www.tradingview.com/news/reuters.com,2024-02-07:newsml_GNX58spfW:0-dypius-enables-secure-cross-chain-nft-transfers-for-caws-and-world-of-dypians-with-chainlink-ccip/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/tradingView.png"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>
              <td className="presscell radius10">
                <a
                  href="https://apnews.com/press-release/accesswire/business-prices-deflation-economy-54076ee83d21025c63d8347c8accc1e2"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/apnews.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius1"></td>
              <td className="presscell radius7">
                {/* <a
                  href="https://www.cryptofolds.com/defi-yield-protocol-dyp-staking-and-governance-is-now-live"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptofold.png"} alt="" />
                </a> */}
                <a
                  href="https://finance.yahoo.com/news/coingecko-dypius-partner-build-pioneer-123000370.html"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/yahoo.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius10">
                <a
                  href="https://www.newsbtc.com/news/company/defi-yield-protocol-launches-staking-and-governance-dapp-dyp-holders-earn-ethereum/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/newsbtc.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius1"></td>
              <td className="presscell radius8"></td>
              <td className="presscell radius1"></td>

              <td className="presscell radius7">
                <a
                  href="https://hackernoon.com/5-defi-projects-you-should-know-about-in-2021-irq347a"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/hackernoon.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius1"></td>
            </tr>
            <tr>
              <td className="presscell radius1">
                <a
                  href="https://blockonomi.com/dyp-staking-app-binance-smart-chain/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/blokonomi.png"} alt="" />
                </a>
              </td>
              <td className="radius10 presscell"></td>
              <td className="presscell radius1">
                <a
                  href="https://techbullion.com/dyp-launches-staking-dapp-on-binance-smart-chain-bsc/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/techbullion.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius6"></td>
              <td className="radius1 presscell"></td>
              <td className="presscell radius4">
                <a
                  href="https://u.today/defi-yield-protocol-launches-staking-and-governance-dapp"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/utoday.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius7"></td>

              <td className="presscell radius1">
                {/* <a
                  href="https://cryptopress.news/defi-yield-protocol-dyp-staking-and-governance-is-now-live/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptopress.png"} alt="" />
                </a> */}
                <a
                  href="https://www.binance.com/en/feed/post/1207307"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/binance.png"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>
              <td className="radius7 presscell"></td>

              <td className="presscell radius10">
                <img src={"https://cdn.worldofdypians.com/dypius/coinspeaker.png"} alt="" />
              </td>
              <td className="presscell radius1">
                {/* <a
                  href="https://www.cryptocompare.com/coins/guides/dypfinance-a-unique-yield-farming-platform/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptocompare.png"} alt="" />
                </a> */}
                <a
                  href="https://hackernoon.com/world-of-dypians-welcomes-coinmarketcap-to-its-dynamic-metaverse-now-available-on-epic-games-store"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/hackernoon.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius7">
                <a
                  href="https://cointelegraph.com/news/yield-farming-platform-announces-it-s-expanding-to-avalanche"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cointelegraph.png"} alt="" />
                </a>
              </td>
              <td className="radius1 presscell"></td>

              <td className="presscell radius7">
                <img src={"https://cdn.worldofdypians.com/dypius/mycointainer.png"} alt="" />
              </td>

              <td className="presscell radius1">
                <a
                  href="https://blockonomi.com/dyp-staking-app-binance-smart-chain/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/blokonomi.png"} alt="" />
                </a>
              </td>
              <td className="radius10 presscell"></td>
              <td className="presscell radius1">
                <a
                  href="https://techbullion.com/dyp-launches-staking-dapp-on-binance-smart-chain-bsc/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/techbullion.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius6"></td>
              <td className="radius1 presscell"></td>
              <td className="presscell radius4">
                <a
                  href="https://u.today/defi-yield-protocol-launches-staking-and-governance-dapp"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/utoday.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius7"></td>

              <td className="presscell radius1">
                {/* <a
                  href="https://cryptopress.news/defi-yield-protocol-dyp-staking-and-governance-is-now-live/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptopress.png"} alt="" />
                </a> */}
                <a
                  href="https://coinmarketcap.com/community/articles/65858dc0b044ba691e692e54/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coinmarketcap.png"} alt="" />
                </a>
              </td>
              <td className="radius7 presscell"></td>

              <td className="presscell radius10">
                <img src={"https://cdn.worldofdypians.com/dypius/coinspeaker.png"} alt="" />
              </td>
              <td className="presscell radius1">
                {/* <a
                  href="https://www.cryptocompare.com/coins/guides/dypfinance-a-unique-yield-farming-platform/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptocompare.png"} alt="" />
                </a> */}
                <a
                  href="https://www.tradingview.com/news/reuters.com,2023-12-22:newsml_GNX2k4ltG:0-world-of-dypians-welcomes-coinmarketcap-to-its-dynamic-metaverse-now-available-on-epic-games-store/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/tradingView.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius7">
                <a
                  href="https://cointelegraph.com/news/yield-farming-platform-announces-it-s-expanding-to-avalanche"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cointelegraph.png"} alt="" />
                </a>
              </td>
              <td className="radius1 presscell"></td>

              <td className="presscell radius7">
                <img src={"https://cdn.worldofdypians.com/dypius/mycointainer.png"} alt="" />
              </td>
            </tr>
            <tr>
              <td className="presscell radius7">
                <img src={"https://cdn.worldofdypians.com/dypius/uptrennd.png"} alt="" />
              </td>
              <td className="radius1 presscell">
              <a
                  href="https://www.binance.com/en-IN/feed/post/3805101087698"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/binance.png"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>

              <td className="presscell radius6">
                <a
                  href="https://coincodex.com/article/11092/earn-compound-yields-on-binance-smart-chain-using-defi-yield-protocol-dyp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coindex.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius1"></td>
              <td className="presscell radius9">
                {/* <a
                  href="https://coindoo.com/dyp-maximizing-the-benefits-of-yield-farming-protocols/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coindoo.png"} alt="" />
                </a> */}
                <a
                  href="https://finance.yahoo.com/now/world-dypians-welcomes-coinmarketcap-dynamic-161500412.html"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/yahoo.png"} alt="" />
                </a>
              </td>

              <td className="radius1 presscell"></td>
              <td className="presscell radius8">
                <a
                  href="https://btcmanager.com/defi-yield-protocol-dyp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coinmanager.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius1"></td>

              <td className="presscell radius2">
                <img src={"https://cdn.worldofdypians.com/dypius/bithumb.png"} alt="" />
              </td>
              <td className="presscell radius1">
                <a
                  href="https://cryptopotato.com/tackling-volatility-issues-for-liquidity-providers-with-defi-yield-protocol-dyp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptopotato.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius5"></td>
              <td className="presscell radius8">
              <a
                  href="https://markets.businessinsider.com/news/stocks/dypius-enables-secure-cross-chain-nft-transfers-for-caws-and-world-of-dypians-with-chainlink-ccip-1033039993"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/businessinsider.png"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>
              <td className="presscell radius1">
                <img src={"https://cdn.worldofdypians.com/dypius/coingape.png"} alt="" />
              </td>

              <td className="presscell radius2"></td>
              <td className="presscell radius7">
                <img src={"https://cdn.worldofdypians.com/dypius/uptrennd.png"} alt="" />
              </td>
              <td className="radius1 presscell"></td>

              <td className="presscell radius6">
                <a
                  href="https://coincodex.com/article/11092/earn-compound-yields-on-binance-smart-chain-using-defi-yield-protocol-dyp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coindex.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius1"></td>
              <td className="presscell radius9">
                {/* <a
                  href="https://coindoo.com/dyp-maximizing-the-benefits-of-yield-farming-protocols/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coindoo.png"} alt="" />
                </a> */}
                <a
                  href="https://www.binance.com/en-IN/feed/post/1731781535186"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/binance.png"} style={{borderRadius: "50%"}} alt="" />
                </a>
              </td>

              <td className="radius1 presscell"></td>
              <td className="presscell radius8">
                <a
                  href="https://btcmanager.com/defi-yield-protocol-dyp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coinmanager.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius1"></td>

              <td className="presscell radius2">
                <img src={"https://cdn.worldofdypians.com/dypius/bithumb.png"} alt="" />
              </td>
              <td className="presscell radius1">
                <a
                  href="https://cryptopotato.com/tackling-volatility-issues-for-liquidity-providers-with-defi-yield-protocol-dyp/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/cryptopotato.png"} alt="" />
                </a>
              </td>
              <td className="presscell radius5"></td>
              <td className="presscell radius8"></td>
              <td className="presscell radius1">
                <a
                  href="https://coingape.com/how-to-use-dyp-to-earn-big-defi-rois/"
                  target="_blank"
                  rel="noreferrer nofollow"
                >
                  <img src={"https://cdn.worldofdypians.com/dypius/coingape.png"} alt="" />
                </a>
              </td>

              <td className="presscell radius2"></td>
            </tr>
          </tbody>
        </table>
        <div className="rightbg"></div>
      </div>
    </div>
  );
};

export default PressRelease;
